import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/agencyOrderBundle/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/agencyOrderBundle/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/agencyOrderBundle/UPDATE_FAILURE'

// Initial State
const initialState = {
  updating: false,
  errors: [],
}

// Actions
export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function bulkUpdateIds(orderBundle, agencyIds, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      permissions: agencyIds,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/order_bundles/${orderBundle.id}/update_agencies.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Clear existing permissions
        const state = getState()
        const agencyOrderBundles = state.entities.agencyOrderBundles
        const keys = Object.keys(agencyOrderBundles)
        keys.forEach((key) => {
          const object = agencyOrderBundles[key]
          if (object && object.order_bundle_id === orderBundle.id){
            const normalized = normalize(object, Schemas.AGENCY_ORDER_BUNDLE)
            dispatch(deleteEntity(normalized))
          }
        })

        const normalizedJson = normalize(json, Schemas.AGENCY_ORDER_BUNDLE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
